import { Injectable, inject } from '@angular/core';

import { AppInfoConfig, Page, ProductService } from '@frontend/vanilla/core';

import { GeoCoordinatorClientConfig } from './client-config';
import { GeoCoordinatorPLCIdentifierService } from './plcIdentifier.service';

@Injectable({
    providedIn: 'root',
})
export class TextReplacementService {
    private readonly appInfo = inject(AppInfoConfig);
    private readonly page = inject(Page);
    private readonly plcIdentifierService = inject(GeoCoordinatorPLCIdentifierService);
    private readonly geoCoordinatorConfig = inject(GeoCoordinatorClientConfig);
    private readonly productService = inject(ProductService);

    replace(replacementTarget: string) {
        return this.replacePluginLoadSettings(this.applyReplacers(replacementTarget));
    }
    private applyReplacers(replaceTarget: string) {
        return (
            replaceTarget
                .replace?.(/{channel}/gi, this.appInfo.channel || '')
                .replace?.(/{env}/gi, this.page.environment || '')
                .replace?.(/{plcIdentifier}/gi, this.plcIdentifierService.identifier || '')
                .replace?.(/{accessId}/gi, this.geoCoordinatorConfig.apiToken ?? '')
                .replace?.(/{currentProduct}/gi, this.productService.current.name) ?? replaceTarget
        );
    }

    private serializePluginSettings(separator: string) {
        return Object.entries(this.geoCoordinatorConfig.pluginLoadSettings ?? {})
            .map(([key, value]) => `${key}=${this.applyReplacers(value)}`)
            .join(separator);
    }

    private replacePluginLoadSettings(replaceTarget: string) {
        return replaceTarget.replace?.(/{pluginLoadSettings}/gi, this.serializePluginSettings('&')) ?? replaceTarget;
    }
}
